import { inject, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { exhaustMap, map } from "rxjs";
import { SessionActions } from "../../../features/authentication/store/session.actions";
import { RealtimeActions } from "../store/realtime.actions";
import { SessionConflictDialogComponent, SessionConflictResult } from "./session-conflict-dialog.component";

@Injectable()
export class SessionConflictEffects {
    private readonly actions$ = inject(Actions);
    private readonly dialog = inject(MatDialog);

    readonly showConflict$ = createEffect(() => this.actions$.pipe(
        ofType(RealtimeActions.multipleRegistrationDetected),
        exhaustMap(() => {
            this.dialog.closeAll();
            return this.dialog.open<SessionConflictDialogComponent, never, SessionConflictResult>(
                SessionConflictDialogComponent,
                {
                    autoFocus: ".restore-session",
                    closeOnNavigation: false,
                    disableClose: true,
                    panelClass: "app-dialog-panel",
                    restoreFocus: false,
                    role: "alertdialog",
                },
            ).afterClosed();
        }),
        map((result) => result === "restore"
            ? RealtimeActions.restoreSessionRequested()
            : SessionActions.logoutRequested()),
    ));
}
